<div fxLayout="column">
    <div [formGroup]="form" fxFlex="100%" fxLayout="row wrap"> 
        <div [fxFlex]="operatorAvailable ? '50%' : '100%'" fxLayout="row wrap">
            <div [ngStyle.gt-sm]="'width: 30%'" [ngStyle.lt-sm]="'width: 90%'" fxLayout="column"
            [ngClass]="operatorAvailable ? 'w-180' : 'w-140'">
                <mat-label class="font-weight-400">{{'REPORT.FILTERS.DATEFROM' | translate}}</mat-label>
                <mat-form-field appearance="outline" floatLabel="always" color="accent" class="mr-8 my-4">
                    <input matInput 
                        [matDatepicker]="dateFromControl" 
                        [placeholder]="placeholder"
                        [min]="minDate"
                        formControlName="dateFrom" [readonly]="readonly" [required]="required" (keydown)="handleKeyDown($event)">
                    <mat-datepicker-toggle 
                        matSuffix 
                        [for]="dateFromControl" [disabled]="readonly">
                    </mat-datepicker-toggle>                                
                    <mat-datepicker #dateFromControl disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
        
            <div [ngStyle.gt-sm]="'width: 30%'" [ngStyle.lt-sm]="'width: 90%'" fxLayout="column"
            [ngClass]="operatorAvailable ? 'w-180' : 'w-140'">
                <mat-label class="font-weight-400">{{"REPORT.FILTERS.DATETO" | translate}}</mat-label>
                <mat-form-field appearance="outline" floatLabel="always" color="accent" class="mr-8 my-4">
                    <input matInput 
                        [matDatepicker]="dateToControl" 
                        [placeholder]="placeholder"
                        [min]="minDate"
                        formControlName="dateTo" [readonly]="readonly" (keydown)="handleKeyDown($event)">
                    <mat-datepicker-toggle 
                        matSuffix 
                        [for]="dateToControl" [disabled]="readonly">
                    </mat-datepicker-toggle>                                
                    <mat-datepicker #dateToControl [disabled]="operatorSelected == QUESTION_OPERATOR.DateFromWithValue ? true : false"></mat-datepicker>
                </mat-form-field>
            </div>
        
            <div [ngStyle.gt-sm]="'width: 30%'" [ngStyle.lt-sm]="'width: 90%'" fxLayout="column"
            [ngClass]="operatorAvailable ? 'w-180' : 'w-140'">
                <mat-label class="font-weight-400">{{"REPORT.FILTERS.DATE_RANGE" | translate}}</mat-label>
                <mat-form-field appearance="outline" floatLabel="always" color="accent" class="mr-8 my-4">
                    <input matInput formControlName="calculatedDays" class="p-4">
                </mat-form-field>
            </div>
        </div>

        <div class="m-8 p-8 px-0" fxFlex.gt-sm="30%" fxLayout="column" *ngIf="operatorAvailable">
            <mat-radio-group (change)="handleQuestionOperator($event)">
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.HigherThan}}" 
                [checked]="QUESTION_OPERATOR.HigherThan === operatorSelected"
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.HigherThan)">
                    {{"QUESTION_OPERATOR.HigherThan" | translate}}
                </mat-radio-button><br>
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.LessThan}}"
                [checked]="QUESTION_OPERATOR.LessThan === operatorSelected"
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.LessThan)">
                    {{"QUESTION_OPERATOR.LessThan" | translate}}
                </mat-radio-button><br>
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.Equals}}"
                [checked]="QUESTION_OPERATOR.Equals === operatorSelected"
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.Equals)">
                    {{"QUESTION_OPERATOR.Equals" | translate}}
                </mat-radio-button><br>
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.Empty}}"
                [checked]="QUESTION_OPERATOR.Empty === operatorSelected" 
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.Empty)">
                    {{"QUESTION_OPERATOR.Empty" | translate}}
                </mat-radio-button>
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.Completed}}"
                [checked]="QUESTION_OPERATOR.Completed === operatorSelected" 
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.Completed)">
                    {{"QUESTION_OPERATOR.Completed" | translate}}
                </mat-radio-button>
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.Between}}"
                [checked]="QUESTION_OPERATOR.Between === operatorSelected" 
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.Between)">
                    {{"QUESTION_OPERATOR.Between" | translate}}
                </mat-radio-button>
                <mat-radio-button class="m-4" value="{{QUESTION_OPERATOR.DateFromWithValue}}"
                [checked]="QUESTION_OPERATOR.DateFromWithValue === operatorSelected" 
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.DateFromWithValue)">
                    {{"QUESTION_OPERATOR.DateFromWithValue" | translate}}
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>